import InputSingleEntityFieldLocal from "components/form/fields/InputSingleEntityFieldLocal";
import InputSingleEntityField      from "components/form/fields/InputSingleEntityField";
import { useFieldInfo }            from "contexts/FieldInfoContext";

const InputSingleEntitySelectField = (props: any) => {
  const { info }  = useFieldInfo()

    
  if (info.numOptions >= 0 && info.numOptions < 100 && !info.isDepending)
    return <InputSingleEntityFieldLocal {...props}/>
  else
    return <InputSingleEntityField {...props} />
}

export default InputSingleEntitySelectField
